<template>
  <div class="poiDetail" v-show="isVisible" :style="{left:x+'px', top:y+'px'}">
    <div class="header">
      <!-- <span>{{poiName}}</span> -->
      <el-tooltip :content="poiName" placement="top" effect="light" :open-delay="1000" :enterable="false">
        <span>{{poiName}}</span>
      </el-tooltip>
      <Icon type="big" name="el-icon-close" @click="close"></Icon>
    </div>
    <div class="divider"></div>
    <div class="content">
      <div class="location">
        <!-- <icon-font type="icon-daohangdizhi"/> -->
        <!-- <Icon type="big" name="el-icon-close" disabled></Icon> -->
        <svg width="1em" height="1em" fill="currentColor" aria-hidden="true">
          <use xlink:href="#icon-dian"></use>
        </svg>
        <span>{{address}}</span>
      </div>
      <div class="telphone" v-show="false">
        <!-- <icon-font type="icon-dianhua"/> -->
        <!-- <Icon type="big" name="el-icon-close" disabled></Icon> -->
        <svg width="1em" height="1em" fill="currentColor" aria-hidden="true">
          <use xlink:href="#icon-dianhua"></use>
        </svg>
        <span>{{telephone}}</span>
      </div>
      <el-button v-show="isShowMarkerBtn" type="primary" @click="showAttribute" class="marker-button" :disabled="permissionLevel <= PermissionLevel.LOOKER">转为标注</el-button>
    </div>
    <div class="triangle-down"></div>
  </div>
</template>

<script>
import { PermissionLevel } from '@/configs/constants'
import { mapGetters } from 'vuex'
export default {
  name: 'PoiDetail',
  data () {
    return {
      isVisible: false,
      poiData: {},
      // 名称
      poiName: '',
      // 地址
      address: '',
      // 电话
      telephone: '',
      x: 400,
      y: 200,
      isShowMarkerBtn: true,
      PermissionLevel
    }
  },
  computed: {
    ...mapGetters([
      'permissionLevel'
    ])
  },
  watch: {
    $route (to, from) {
      this.isShowMarkerBtn = to.name === 'Marker'
    }
  },
  mounted () {
    this.isShowMarkerBtn = this.$route.name === 'Marker'
    this.$cesiumPlus.viewer.scene.camera.changed.addEventListener(() => {
      this.updatePos()
    })
  },
  methods: {
    show (data) {
      this.isVisible = true
      this.poiName = data.name
      this.address = data.address
      this.telephone = data.tel
      this.markerId = `poisearch-${data.id}`
      this.poiData = data
    },
    // 更新位置
    updatePos () {
      if (!this.$cesiumPlus.viewer || !this.isVisible || !this.markerId) {
        return
      }
      const marker = this.$cesiumPlus.markerManager.getMarkerById(this.markerId)
      if (!marker) {
        this.show(false)
        return
      }
      const pos = marker.getScreenPos(this.$cesiumPlus.viewer)
      this.x = pos[0] - 130
      this.y = pos[1] - 200
    },
    close () {
      this.poiName = ''
      this.address = ''
      this.telephone = ''
      this.markerId = ''
      this.poiData = {}
      this.isVisible = false

      const sources = this.$cesiumPlus.markerManager.getDataSourceByLayer('poisearch')
      if (sources && sources.entities.values.length > 0) {
        for (let i = 0; i < sources.entities.values.length; i++) {
          const entity = sources.entities.values[i]
          const marker = this.$cesiumPlus.markerManager.getMarkerById(entity.id)
          if (!marker) {
            continue
          }
          const index = marker.properties.index
          marker.setStyle([
            new CesiumPlus.BillboardStyle({
              image: require(`@/assets/images/red${index + 1}.png`),
              show: true
            })
          ])
        }
      }
    },
    showAttribute () {
      this.$store.commit('SET_POI2MARKER', this.poiData)
      this.isVisible = false
    }
  }
}
</script>

<style lang="scss">
.poiDetail{
  position: absolute;
  width: 260px;
  height: 148px;
  background: rgba(#242526, 0.9);
  border: 1px solid #565759;
  border-radius: 12px;

  .header{
      width: 100%;
      height: 40px;
      font-size: 16px;
      color: #FFFFFF;
      line-height: 40px;
      // margin-left: 12px;
      span {
        display: inline-block;
        width: 210px;
        height: 27px;
        padding-left: 10px;
        text-align: left;
        overflow: hidden;
      }
    }
    .divider {
      width: 100%;
      height: 1px;
      background: #555555;
      margin: 0
      // border: 1px solid #555555;
    }
    .content{
      font-size: 14px;
      color: #BBBBBB;
      margin-bottom: 11px;
      display: flex;
      flex-direction: column;
      .location {
        display: flex;
        margin-top: 10px;
        span {
          display: -webkit-box;
          width: 2.2rem;
          height: 45px;
          overflow: hidden;
          text-align: left;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          /* autoprefixer: ignore next */
          -webkit-box-orient: vertical;
        }
      }
      .telphone {
        display: flex;
        span {
          display: inline-block;
          width: 120px;
          max-height: 20px;
          overflow: hidden;
          text-align: left;
          text-overflow:ellipsis;
        }
      }
      svg{
        color: #BBBBBB;
        font-size: 20px;
        margin: 0 8px;
      }
      .marker-button{
        width: 80px;
        position: absolute;
        right: 20px;
        bottom: 15px;
      }
    }
    .triangle-down{
      width: 0;
      height: 0;
      border-left: 12px solid transparent;
      border-right: 12px solid transparent;
      border-top: 12px solid rgba(#242526, 0.9);
      margin: 0px auto;
      margin-top: 50px;
    }
}
</style>
